import { render, staticRenderFns } from "./spr-fail.vue?vue&type=template&id=f2c6cb80&scoped=true&"
import script from "./spr-fail.vue?vue&type=script&lang=js&"
export * from "./spr-fail.vue?vue&type=script&lang=js&"
import style0 from "./spr-fail.vue?vue&type=style&index=0&id=f2c6cb80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c6cb80",
  null
  
)

export default component.exports